module.exports = __webpack_public_path__ + "static/media/iconTrackingActive.f31987fd.svg";